import { agreementService } from '@/_services'
export const agreement = {
  namespaced: true,
  state: {
    myAgreement: null,
    signedAgreements: null,
    agreementStatus: null,
    notViewedMyAgreement: null,
    availableYears: null
  },

  getters: {
  },

  mutations: {
    setMyAgreement(state, agreement){
      state.myAgreement = agreement
      if(agreement.signedAgreements && agreement.signedAgreements.length) state.signedAgreements = agreement.signedAgreements
      else state.signedAgreements = null
    },

    setSignedAgreements(state, agreement) {
      state.signedAgreements = agreement.signedAgreements
    },

    setAgreementStatus(state, status) {
      state.myAgreement.viewed = status
      let index = state.notViewedMyAgreement.findIndex((item) => item.id == state.myAgreement.id)
      if (index !== -1) {
        state.notViewedMyAgreement.splice(index, 1)
      }
    },

    deleteMyAgreement(state, agreement) {
      if(state.myAgreement && agreement.id == state.myAgreement.id) {
        state.myAgreement = null
      }
    },

    changeAgreementEditable(state, status) {
      if(state.myAgreement) {
        state.myAgreement.editable = status
      }
    },

    setAvailableYears(state, availableYears) {
      state.availableYears = availableYears
    },

    setNotViewedMyAgreement(state, agreement) {
      state.notViewedMyAgreement = agreement
    },

    setNotViewedAgreementFromWebSocket(state, agreement) {
      if(state.notViewedMyAgreement) {
        if(!state.notViewedMyAgreement.some(el => el.id == agreement.id)){
          state.notViewedMyAgreement.push(agreement)
        }
      } else {
        state.notViewedMyAgreement = [].push(agreement)
      }
    },

    deleteNotViewedAgreementFromWebSocket(state, agreement) {
      let index = state.notViewedMyAgreement.findIndex((item) => item.id == agreement.id)
      if (index !== -1) {
        state.notViewedMyAgreement.splice(index, 1)
      }
    }
  },

  actions: {
    loadMyAgreement({ commit, dispatch }, { month, year }) {
      return agreementService.loadMyAgreement(month, year).then(data => {
        commit('setMyAgreement', data)
        if(data && !data.viewed) {
          dispatch('checkMyAgreement', data.id)
        }
      })
    },

    loadAvailableYears({ commit }) {
      return agreementService.getAvailableYears().then(data => {
        commit("setAvailableYears", data)
      })
    },

    loadNotViewedMyAgreement({ commit }) {
      return agreementService.getNotViewedMyAgreement().then(data => {
        commit("setNotViewedMyAgreement", data)
      })
    },

    saveLoadAgreements({ commit }, obj) {
      return agreementService.saveLoadAgreement(obj).then(data => {
        commit('setSignedAgreements', data)
      })
    },

    checkMyAgreement({ commit }, agreementId) {
      return agreementService.checkAgreement(agreementId).then(() => {
        commit("setAgreementStatus", true)
      })
    }
  }
}